module.exports = __webpack_public_path__ + "static/media/photo-camera.22c4c9dc.svg";